// import inventory from './inventory';
import order from "./order";
import orderList from "./order-list"
// import profile from './profile';
// import payment from './paymant';
// import cart from './cart';
import cmsProfile from "./cms-profile";
// import verificationDocument from './verification-document';
import account from "./account";
import reports from "./reports";
import report_option from "./report_option";
import customer_details from "./customer_details";
import customer_location_details from "./customer_location_details";
import driver_management from "./driver_management";
import order_setting from "./order-setting";
import user_profile from "./user-profile";
import customer_setting from "./customer-settings";
import trolley_details from "./trolley-details";
import slots_data from "./slots-data";
import last_mile_box_parcels from "./last-mile-box-parcel";
import reverse_geocoding from "./reverse_geocoding";
import validate_geocoding from "./validate_geocoding";
import employee from "./employee";
import order_version_history from "./order_version_history";
import fullscreen_config from "./fullscreen-config";
import public_fullscreen from "./public-fullscreen";
import customer_rate_table from "./customer_rate_table";

export default {
  // inventory,
  order,
  orderList,
  // profile,
  // payment,
  // cart,
  cmsProfile,
  // verificationDocument,
  employee,
  reverse_geocoding,
  validate_geocoding,
  customer_setting,
  account,
  reports,
  report_option,
  customer_details,
  customer_location_details,
  driver_management,
  order_setting,
  order_version_history,
  user_profile,
  trolley_details,
  slots_data,
  last_mile_box_parcels,
  fullscreen_config,
  public_fullscreen,
  customer_rate_table,
};
